import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  error: null,
  designations: [],
  selectedDesignation: null,
};

const designationSlice = createSlice({
  name: "companyDesignation",
  initialState,
  reducers: {
    // Get Designations
    getDesignationsStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    getDesignationsSuccess: (state, action) => {
      state.loading = false;
      state.designations = action.payload;
      state.error = null;
    },
    getDesignationsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Create Designation
    createDesignationStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    createDesignationSuccess: (state, action) => {
      state.loading = false;
      state.designations.push(action.payload);
      state.error = null;
    },
    createDesignationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Designation Status
    updateDesignationStatusStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateDesignationStatusSuccess: (state, action) => {
      state.loading = false;
      const index = state.designations.findIndex(
        (des) => des.id === action.payload.id,
      );
      if (index !== -1) {
        state.designations[index].status = action.payload.status;
      }
      state.error = null;
    },
    updateDesignationStatusFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update Designation
    updateDesignationStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateDesignationSuccess: (state, action) => {
      state.loading = false;
      const index = state.designations.findIndex(
        (des) => des.id === action.payload.id,
      );
      if (index !== -1) {
        state.designations[index] = action.payload;
      }
      state.error = null;
    },
    updateDesignationFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Set Selected Designation
    setSelectedDesignation: (state, action) => {
      state.selectedDesignation = action.payload;
    },

    // Clear Error
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const {
  getDesignationsStart,
  getDesignationsSuccess,
  getDesignationsFailure,
  createDesignationStart,
  createDesignationSuccess,
  createDesignationFailure,
  updateDesignationStatusStart,
  updateDesignationStatusSuccess,
  updateDesignationStatusFailure,
  updateDesignationStart,
  updateDesignationSuccess,
  updateDesignationFailure,
  setSelectedDesignation,
  clearError,
} = designationSlice.actions;

export default designationSlice.reducer;
